// extracted by mini-css-extract-plugin
module.exports = {"phone":"AuthCodeStep__phone__1kruu","resendBtnWrap":"AuthCodeStep__resendBtnWrap__2cS13","phoneEditBtn":"AuthCodeStep__phoneEditBtn__o--4u"};